import { Box, Container, Grid, Paper } from "@mui/material"
import React, { useEffect, useState } from "react"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined"
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined"
import Card from "@mui/material/Card"
import apiClient from "../../api/apiClient"
import { Helmet } from "react-helmet"

function Dashboard() {
  const [sampleAss, setSampleAss] = useState(0)
  const [report, setReport] = useState(0)

  const fetchData = async () => {
    try {
      const [sampleAssResult, apiReport] = await Promise.all([
        apiClient.get("/sample/?sampleStatus=ASS"),
        apiClient.get("/report/user-reports/")
      ])

      if (sampleAssResult.ok && apiReport.ok) {
        // Filter the samples with sampleStatus "Ass"

        const sampleAssCount = sampleAssResult.data.results.length
        const reportCount = apiReport.data.count

        // Update the state with the retrieved data
        setSampleAss(sampleAssCount)
        setReport(reportCount)

        //console.log(sampleAssCount, "setSampleAss");
        //console.log(reportCount, "setReport");
      }
    } catch (error) {
      //console.log(error);
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const stats = [
    {
      title: "Samples Assigned",
      value: sampleAss,
      icon: <ScienceOutlinedIcon />,
      color: "#d29b12",
      backgroundColor: "#fff6dc"
    },
    {
      title: "Reports Generated",
      value: report,
      icon: <PictureAsPdfOutlinedIcon />,
      color: "#e83f70",
      backgroundColor: "#ffe8f0"
    }
  ]

  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh", pb: 6 }}>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>

      <Container maxWidth={false} sx={{ maxWidth: 1180, px: { xs: 2, md: 3 } }}>
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: "#3f4a5a", mb: 0.5 }}>
                Dashboard
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Your assigned samples and report activity at a glance.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid
            item
            md={11}
            xs={12}
            component={Paper}
            elevation={0}
            sx={{
              p: { xs: 2, md: 4 },
              borderRadius: "18px",
              border: "1px solid #e7eaf0",
              boxShadow: "0 18px 46px rgba(15, 23, 42, 0.1)",
              backgroundColor: "#fff"
            }}>
            <Grid container spacing={2.5} justifyContent="center">
              {stats.map(item => (
                <Grid key={item.title} item md={4} sm={6} xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      height: "100%",
                      borderRadius: "10px",
                      border: "1px solid #edf0f4",
                      boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
                      transition: "transform 160ms ease, box-shadow 160ms ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.12)"
                      }
                    }}>
                    <CardContent sx={{ display: "flex", alignItems: "center", gap: 1.75, p: 2.5 }}>
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: item.backgroundColor,
                          color: item.color,
                          borderRadius: "10px",
                          fontSize: 30,
                          flexShrink: 0
                        }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
                          {item.title}
                        </Typography>
                        <Typography variant="h4" sx={{ color: "#121826", fontWeight: 700, lineHeight: 1.15 }}>
                          {item.value}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
export default Dashboard
